<div class="card">
    <p-card>
        <ng-template pTemplate="header">
            <div class="flex flex-row flex-row-reverse p-1 pr-6">
                <p-button *ngIf="activeSubmission" icon="pi pi-file-import" [rounded]="true" [text]="true" [raised]="true" (onClick)="fillFromSubmission()"></p-button>
                <p-button icon="pi pi-eraser" [rounded]="true" [text]="true" [raised]="true" (onClick)="clearForm()" class="mr-2 ml-2"></p-button>
            </div>
        </ng-template>
        <div class="grid formgrid p-fluid">
            <div class="field mt-2 col-6">
                <span>
                    <p-floatLabel>
                        <input id="FirstName" pInputText [(ngModel)]="adjuster.firstName" />
                        <label for="FirstName">First Name</label>
                    </p-floatLabel>
                </span>
            </div>
            <div class="field mt-2 col-6">
                <span>
                    <p-floatLabel>
                        <input id="LastName" pInputText [(ngModel)]="adjuster.lastName" />
                        <label for="LastName">Last Name</label>
                    </p-floatLabel>
                </span>
            </div>
            <div class="field mt-2 col-6">
                <span>
                    <p-floatLabel>
                        <input id="Email" pInputText [(ngModel)]="adjuster.emailAddress" />
                        <label for="Email">Email</label>
                    </p-floatLabel>
                </span>
            </div>
            <div class="field mt-2 col-6">
                <span>
                    <p-floatLabel>
                        <input id="PhoneNumber" pInputText [(ngModel)]="adjuster.phoneNumber" />
                        <label for="PhoneNumber">Phone Number</label>
                    </p-floatLabel>
                </span>
            </div>
            <div class="flex mt-2 col-12 justify-content-center" >
                <p-buttonGroup>
                    <p-button label="Save" icon="pi pi-check" (onClick)="saveButtonPressed($event)" [disabled]="!allowSave()"></p-button>
                    <p-button label="Cancel" icon="pi pi-times" severity="danger" (onClick)="cancelButtonPressed($event)"></p-button>
                </p-buttonGroup>
            </div>
        </div>
        
    </p-card>
</div>